module.exports = __webpack_public_path__ + "img/mobile_pipeline_top_img.c1249f42.jpg";